import { useEffect, useState } from 'react';
import { first } from 'rxjs/operators';
import { IVivliConfiguration, IVivliConfigurationApi } from '@vivli/shared/infrastructure/interface';
import { IActiveUser, IAuthService } from '@vivli/core/infrastructure/interface';

interface IVivliConfigProps {
    vivliConfigApi: IVivliConfigurationApi;
    activeUser: IActiveUser;
}

export function useVivliConfig({ vivliConfigApi, activeUser }: IVivliConfigProps) {
    const [vivliConfig, setVivliConfig] = useState<IVivliConfiguration>();

    useEffect(() => {
        if (activeUser.user === null || vivliConfig) {
            return;
        }

        const sub = vivliConfigApi
            .getVivliConfig()
            .pipe(first((config) => config !== null))
            .subscribe(setVivliConfig);

        return () => {
            sub.unsubscribe();
        };
    }, [activeUser.user, vivliConfigApi]);

    return vivliConfig;
}
